import { render, staticRenderFns } from "./ComparativoFaturamentoTime.vue?vue&type=template&id=9abef018&scoped=true&"
import script from "./ComparativoFaturamentoTime.vue?vue&type=script&lang=js&"
export * from "./ComparativoFaturamentoTime.vue?vue&type=script&lang=js&"
import style0 from "./ComparativoFaturamentoTime.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./ComparativoFaturamentoTime.vue?vue&type=style&index=1&id=9abef018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abef018",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VIcon,VRow})
